import { MODEL as MODEL_USER } from '../../user/components/UserModel';

export const _LOAD_MODEL_ = 'Load:CommercialModel';
export const _DELETE_COMMERCIAL_ = 'Delete:Commercial';
export const _EDIT_COMMERCIAL_ = 'Save:CommercialSuccess';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_RESELLER_SUCCESS_ = 'Save:CommercialSuccess';

export const MODEL = {
  phone: null,
  user_id: null,
  user: { ...MODEL_USER },
  representatives: [],
};
